import React, { Component } from 'react'
import './check-box.css'

class CheckBoxCP extends Component {
  constructor(props) {
    super(props)
    /*
    this.state = {
      value: this.props.value || false
    }
    */
  }

  // componentDidMount() {}

  render() {
    return (
      <div className='bcioInputCircle' name={this.props.objPath} value={this.props.value || false} onClick={event => this._onChange(event)}>
        {(this.props.value || false)
          ? <div className='bcioCheckmark'></div>
          : null
        }
      </div>
    )
  }

  _onChange(event) {
    var isEditable = true // default to true
    if ('isEditable' in this.props) isEditable = this.props.isEditable
    isEditable = isEditable && this.props.meta.displayEditable
    if (!isEditable) return

    const newVal = !(this.props.value || false)
    //this.setState({value: newVal})
    this.props.onChange(event, newVal, this.props.objPath)
  } 
}

export default CheckBoxCP
